import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../barcodeform.css";
import { CSVLink } from "react-csv";

import jQuery from "jquery";
import { getShypvBaseUrl } from "../../utils/utils";
import ReportIssueButton from "./ReportIssueButton";
export default function GetTracking() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [barcode, setBarcode] = useState("");
  const [shipmentDetails, setShipmentDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const $ = jQuery.noConflict();

  useEffect(() => {
    $(".btn-demo.import").on("click", function () {
      $(".nalier.middle-center.fade").css("display", "block");
      $(".nalier.middle-center.fade").addClass("in");
    });

    $(".close.h-close").on("click", function () {
      $(".nalier.middle-center.fade.in").css("display", "none");
      $(".nalier.middle-center.fade").removeClass("in");
    });
  }, []);

  const buttonsyle = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginRight: "10px",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
  };

  const [errormsg, setError] = useState("");

  useEffect(() => {
    // Fetch drivers from the API on component mount

    getUserList();
  }, []);

  const [scaninfo, setScaninfo] = useState({
    driver: "",
  });

  const [awb, setAwb] = useState();

  const [users, setusers] = useState();
  const getUserList = async () => {
    const API_PATH = `${API_URL}shypvdriverapp/personnel/getPersonnels`;

    // Send a GET request to the new API
    try {
      const res = await axios.get(API_PATH);

      console.log(res.data); // Log the response to inspect it

      // Check if the response contains 'data' and if it's an array
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        setusers(res.data.data); // Update the personnel list in the state
      } else {
        console.log(
          "No personnel data found in the response or response is not successful"
        );
      }
    } catch (err) {
      console.log("Error fetching personnel list:", err);
    }
  };

  console.log("scan:", scaninfo);
  console.log("users:", users);

  const getDetails = async () => {
    const awbArray = awb
      .split(/[\n,]+/) // Split by newline or comma
      .map((item) => {
        item = item.trim(); // Trim extra spaces
        if (item.startsWith("E") && item.charAt(item.length - 5) === "D") {
          return item.slice(3, -5); // Slice the specific AWBs
        }
        return item;
      })

      .filter((item) => item !== ""); // Remove empty values
    console.log("AWB Array (to be sent):", JSON.stringify(awbArray));

    try {
      const response = await axios.post(
        `${API_URL}shypvdriverapp/jobs/multipleAwbStatuses`,
        awbArray, // Pass the array in the body as JSON
        {
          headers: {
            "Content-Type": "application/json", // Required header
          },
        }
      );

      console.log("Response Data:", response.data);

      // Handle response data
      if (response.data.success) {
        setShipmentDetails(response.data.data || []);
        if (response.data.data.length === 0) {
          setError("Booking details not found");
        } else {
          setError("");
        }
      } else {
        setShipmentDetails([]);
        setError("Booking details not found");
      }
    } catch (err) {
      console.error("Error:", err.response || err.message);
      setError("An error occurred while fetching details");
    }
  };

  const [errorNew, seterrorNew] = useState("");
  const [expandedRows, setExpandedRows] = useState(new Set());

  const toggleExpandedRow = (index) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  const baseUrl = getShypvBaseUrl();

  const [allStatus, setallStatus] = useState();
  useEffect(() => {
    // Make the API call when the component mounts
    axios
      .get(`${API_URL}shypvdriverapp/jobs/getAllStatus`)
      .then((response) => {
        setallStatus(response.data.data); // Store the data in state
        setLoading(false); // Set loading to false when done
      })
      .catch((err) => {
        setError(err); // Store the error in state if something goes wrong
        setLoading(false); // Set loading to false even if there's an error
      });
  }, []);

  console.log("all", allStatus);

  //   const [updatedDetails, setUpdatedDetails] = useState(shipmentDetails);
  const [newStatus, setnewStatus] = useState(0);

  const handleAwbChange = (e) => {
    // Update the input field value
    setAwb(e.target.value);
  };

  function resetData() {
    setShipmentDetails([]);
    setAwb("");
  }

  function PrintLabel() {
    console.log(awb);

    // Normalize AWBs to a comma-separated list
    const awbList = awb
      .split(/[\n,]+/)
      .map((item) => item.trim())
      .filter(Boolean);
    const awbParam = awbList.join(",");

    // Determine base URL based on current hostname

    const url = `${baseUrl}/multi-print-order?id=${awbParam}`;

    console.log("Generated URL:", url);
    window.open(url, "_blank");
  }

  const handleDownload = (val) => {
    const url = `${baseUrl}/print-order?id=${val}`;
    window.open(url, "_blank");
  };

  const csvHeaders = [
    { label: "AWB", key: "bookingId" },
    { label: "Ref", key: "businessRefNo" },
    { label: "Status", key: "latestStatus" },
    { label: "Last Transit Date", key: "lastTransitDate" },
    { label: "Last Transit Time", key: "lastTransitTime" },
    { label: "Courier", key: "courier" },
    { label: "Shipper", key: "shipper" },
    { label: "Consignee", key: "consignee" },
    { label: "Address", key: "address" },
    { label: "Phone", key: "phone" },
    { label: "COD", key: "codDetails" },
    { label: "Updated By", key: "updatedBy" },
    // Appended, never inserted: these sit AFTER the twelve original columns so an
    // existing spreadsheet template or positional import keeps working unchanged.
    { label: "Pickup Address", key: "pickupAddress" },
    { label: "Shipper Phone", key: "shipperPhone" },
  ];

  const csvData = shipmentDetails.map((data) => ({
    bookingId: data.bookingId,
    businessRefNo: data.businessRefNo,
    latestStatus: data.subStatus
      ? `${data.latestStatus} (${data.subStatus})`
      : data.latestStatus,
    lastTransitDate: new Date(data.lastUpdatedDate).toLocaleDateString(),
    lastTransitTime: new Date(data.lastUpdatedDate).toLocaleTimeString(),
    courier: data.courier,
    shipper: data.shipperDetails?.name || "",
    consignee: data.consigneeDetails?.name || "",
    address: data.consigneeDetails?.address || "",
    phone: data.consigneeDetails?.phone || "",
    codDetails: data.codDetails,
    updatedBy: data.updatedBy,
    pickupAddress: data.shipperDetails?.address || "",
    shipperPhone: data.shipperDetails?.phone || "",
  }));

  console.log("shipmentDetails", shipmentDetails);
  return (
    <div>
      <ReportIssueButton pageContext="BULK_TRACKING" pageLabel="Bulk Tracking" awb={barcode} />
      <div className="form-container">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="driver">AWB: </label>
              <textarea
                id="driver"
                value={awb}
                onChange={handleAwbChange}
                placeholder="Enter AWB, separated by newlines or commas"
                autoFocus
                style={{ minHeight: "120px", width: "100%" }}
              />
            </div>
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <a
                  onClick={getDetails}
                  style={buttonsyle}
                  type="button"
                  className="btn-demo add"
                >
                  Submit
                </a>
                <a
                  onClick={resetData}
                  style={buttonsyle}
                  type="button"
                  className="btn-demo add"
                >
                  Reset
                </a>
                <a
                  onClick={PrintLabel}
                  style={buttonsyle}
                  type="button"
                  className="btn-demo add"
                >
                  Print Label
                </a>
              </div>
            </div>
            <p style={{ color: "red", marginTop: "2%" }}>{errormsg}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-11">
            {loading && <p>Loading shipment details...</p>}

            {shipmentDetails.length > 0 && (
              <div>
                <CSVLink
                  headers={csvHeaders}
                  data={csvData}
                  filename="shipment_details.csv"
                  className="btn btn-primary mb-3"
                  style={{ float: "right", fontSize: "10px" }}
                >
                  <i className="fa fa-download"></i>
                </CSVLink>
                <h4 style={{ textAlign: "left" }}>Track Summary:</h4>

                <div
                  className="shipdata"
                  style={{
                    background: "#5583af59",
                    maxHeight: "500px", // Adjust the height limit as needed
                    overflowY: "auto", // Enables vertical scrolling
                    padding: "10px", // Optional: Add some padding for better visuals
                    border: "1px solid #ccc", // Optional: Add a border for separation
                    marginBottom: "3%",
                  }}
                >
                  <table className="table  table-bordered table-striped">
                    <thead>
                      <tr>
                        <th></th>
                        <th>AWB</th>
                        <th>Ref:</th>
                        <th>Status</th>
                        <th>Last Transit Date</th>
                        <th>Last Transit Time</th>
                        <th>Courier</th>
                        <th>Shipper</th>
                        <th>Consignee</th>

                        <th>Pickup Address</th>
                        <th>Address</th>
                        <th>Phone</th>
                        <th>COD</th>
                        <th>COD Collected</th>
                        <th>Updated By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {shipmentDetails.map((data, index) => (
                        <React.Fragment key={index}>
                        <tr>
                          <td style={{ textAlign: "center" }}>
                            {data.masterAwbNumber && (
                              <i
                                className={`fa ${
                                  expandedRows.has(index)
                                    ? "fa-chevron-down"
                                    : "fa-chevron-right"
                                }`}
                                title="Multi-shipment (MAWB) — click to view child AWBs"
                                style={{ cursor: "pointer", color: "#4f7df3" }}
                                onClick={() => toggleExpandedRow(index)}
                              ></i>
                            )}
                          </td>
                          <td
                            onClick={() => handleDownload(data.bookingId)}
                            style={{ cursor: "pointer" }}
                          >
                            {data.bookingId}

                            <br />
                            <p
                              style={{
                                display: "inline-block",
                                width: "15px",
                                height: "15px",
                                borderRadius: "50%",
                                backgroundColor:
                                  data.type === "PICK_UP"
                                    ? "blue"
                                    : data.type === "DROP"
                                    ? "green"
                                    : "gray",
                                color: "white",
                                textAlign: "center",
                                lineHeight: "15px", // To center the text vertically
                                fontSize: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              {data.type === "PICK_UP"
                                ? "P"
                                : data.type === "DROP"
                                ? "D"
                                : ""}
                            </p>
                          </td>
                          <td>{data.businessRefNo}</td>
                          <td>
                            {data.latestStatus}{" "}
                            {data.subStatus && ` (${data.subStatus})`}{" "}
                          </td>
                          <td>
                            {new Date(
                              data.lastUpdatedDate
                            ).toLocaleDateString()}
                          </td>
                          <td>
                            {new Date(
                              data.lastUpdatedDate
                            ).toLocaleTimeString()}
                          </td>

                          <td>{data.courier}</td>
                          <td>
                            {data.shipperDetails?.name}
                            {data.shipperDetails?.phone ? (
                              <><br /><small style={{ color: "#6b7280" }}>{data.shipperDetails.phone}</small></>
                            ) : null}
                          </td>
                          <td>{data.consigneeDetails?.name}</td>

                          <td>{data.shipperDetails?.address}</td>
                          <td>{data.consigneeDetails?.address}</td>
                          <td>{data.consigneeDetails?.phone}</td>
                          <td>{data.codDetails}</td>
                          <td>{data.cashCollected}</td>
                          <td>{data.updatedBy}</td>
                        </tr>
                        {data.masterAwbNumber && expandedRows.has(index) && (
                          <tr>
                            <td colSpan={15} style={{ background: "#f8fafc", padding: "10px 16px" }}>
                              <div style={{ marginBottom: "8px", fontSize: "13px", color: "#374151" }}>
                                <i className="fa fa-sitemap" style={{ marginRight: "6px" }} />
                                Master AWB: <strong style={{ fontFamily: "monospace" }}>{data.masterAwbNumber}</strong>
                                {" "}&mdash; child AWBs each have their own independent status.
                              </div>
                              {data.childAwbs && data.childAwbs.length > 0 ? (
                                <table className="table table-bordered table-striped" style={{ fontSize: "13px", background: "#fff" }}>
                                  <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>Child AWB</th>
                                      <th>Title</th>
                                      <th>Piece Ref</th>
                                      <th>Description</th>
                                      <th>Weight</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data.childAwbs.map((c, i) => (
                                      <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td style={{ fontFamily: "monospace" }}>{c.childAwb || "-"}</td>
                                        <td>{c.title || "-"}</td>
                                        <td>{c.pieceReference || "-"}</td>
                                        <td>{c.description || "-"}</td>
                                        <td>{c.weight != null ? c.weight : "-"}</td>
                                        <td>{c.status || "-"}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ) : (
                                <div style={{ fontSize: "12px", color: "#6b7280" }}>No child AWBs found.</div>
                              )}
                            </td>
                          </tr>
                        )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
